export default __webpack_public_path__ + "static/ex1-signature-072128fc79bd4d628b54efa06df683ce.webp";